export enum CookieName {
    /**
     * Server-side only. Not visible to front-end code.
     */
    REFRESH_TOKEN_FE = 'pluto.auth.refresh_token.fe',
}
